
export const buildMedicalProviderPaths = ({ selectedTiffIndex, providerType }) => ({
  records: `clients.${selectedTiffIndex}.medicalProviders.${providerType}.medicalRecords`,

  providerName: (providerIndex) =>
    `clients.${selectedTiffIndex}.medicalProviders.${providerType}.medicalRecords.${providerIndex}.providerName`,

  source: (providerIndex) =>
    `clients.${selectedTiffIndex}.medicalProviders.${providerType}.medicalRecords.${providerIndex}.source`,
});

export const buildLiabilityPaths = () => ({
  files: (fileKey) => `liability.${fileKey}`,

  fileDefendants: (fileKey, fileIndex) =>
    `liability.${fileKey}.${fileIndex}.defendants`,

  accidentSceneFiles: {
    base: 'liability.accidentSceneFiles',
    isLiability: (fileIndex) => `liability.accidentSceneFiles.${fileIndex}.isLiability`,
    defendants: (fileIndex) => `liability.accidentSceneFiles.${fileIndex}.defendants`,
  },

  policeReportData: {
    base: 'liability.policeReportData',
    defendants: (fileIndex) => `liability.policeReportData.${fileIndex}.defendants`,
  },
});

export const buildPainSufferingPaths = ({ selectedTiffIndex }) => ({
  bodilyInjuries: {
    files: `clients.${selectedTiffIndex}.painAndSuffering.bodilyInjuriesImageFiles`,
    isSelected: (fileIndex) =>
      `clients.${selectedTiffIndex}.painAndSuffering.bodilyInjuriesImageFiles.${fileIndex}.isSelected`,
  },
  age: `clients.${selectedTiffIndex}.personalInfo.age`,
  gender: `clients.${selectedTiffIndex}.personalInfo.gender`,
  monthlyAmount: `clients.${selectedTiffIndex}.painAndSuffering.monthlyamount`,
  annualAmount: `clients.${selectedTiffIndex}.painAndSuffering.annualamount`,
  isPastTotalAmount: `clients.${selectedTiffIndex}.painAndSuffering.isPastTotalAmount`,
  isFutureTotalAmount: `clients.${selectedTiffIndex}.painAndSuffering.isFutureTotalAmount`,
  totalPastAmount: `clients.${selectedTiffIndex}.painAndSuffering.totalPastAmount`,
  totalFutureAmount: `clients.${selectedTiffIndex}.painAndSuffering.totalFutureAmount`,
  selectedPainPoints: `clients.${selectedTiffIndex}.painAndSuffering.selectedPainPoints`,
  descriptionText: `clients.${selectedTiffIndex}.painAndSuffering.descriptionText`
});

export const buildEconomicDamagePaths = ({ selectedTiffIndex }) => ({
  lossOfEarning: `clients.${selectedTiffIndex}.damage.lossOfEarning`,
  futureMedicalExpense: `clients.${selectedTiffIndex}.damage.futureMedicalExpense`,
  typeOfWork: `clients.${selectedTiffIndex}.damage.typeofWork`,
  workHoursMissed: `clients.${selectedTiffIndex}.damage.workHoursMissed`,
  hourlyIncomeRate: `clients.${selectedTiffIndex}.damage.hourlyIncomeRate`,
  isProcessLifeCarePlan: `clients.${selectedTiffIndex}.damage.isProcessLifeCarePlan`,
  certifiedLifecarePlan: `clients.${selectedTiffIndex}.damage.certifiedLifecarePlan`
});

export const buildCaseInfoPaths = () => ({
  field: (fieldName) => `caseInfo.${fieldName}`,

  letterOfProtection: 'caseInfo.letterOfProtection',
  noticeOfRepresentation: 'caseInfo.noticeOfRepresentation',
  caseNumber: 'caseInfo.caseNumber',
  caseName: 'caseInfo.caseName',
  caseType: 'caseInfo.caseType'
});

export const buildDiscoveryExhibitPaths = () => ({
  base: 'discoveryExhibits',

  title: (exhibitIndex) => `discoveryExhibits.${exhibitIndex}.title`,

  shortDescription: (exhibitIndex) => `discoveryExhibits.${exhibitIndex}.shortDescription`,

  documents: (exhibitIndex) => `discoveryExhibits.${exhibitIndex}.documents`,
});

export const buildClientPaths = ({ selectedTiffIndex }) => ({
  personalInfo: {
    field: (fieldName) => `clients.${selectedTiffIndex}.personalInfo.${fieldName}`,
  },
});

export const buildDefendantLiabilityPaths = ({ selectedDefendant }) => ({
  howIncidentOccurred: `liability.howincidentOccured.${selectedDefendant}.text`,
  dangerousConditions: `liability.dangerousConditions.${selectedDefendant}.text`,
  factsRegardingNotice: `liability.factsRegardingNotice.${selectedDefendant}.text`,
});

export const buildClientUpdatePayload = (formPayloadArray) => {
  const result = {};
  formPayloadArray.forEach(client => {
    result[`clients.{clientId:${client.clientId}}.personalInfo`] = client.personalInfo || {};
    result[`clients.{clientId:${client.clientId}}.insurance`] = client.insurance || {};
  });
  return result;
};

export const buildClientAddPayload = (client) => {
  const result = {
    clientId: client.clientId,
    personalInfo: client.personalInfo || {},
    insurance: client.insurance || {}
  }

  return result;
};

export const buildDefendantAddPayload = (defendant) => {
  const result = {
    defendantId: defendant.defendantId,
    personalInfo: defendant.personalInfo || {},
    insurance: defendant.insurance || {}
  }
  return result;
};



export const buildDefendantUpdatePayload = (formPayloadArray) => {
  const result = {};
  formPayloadArray.forEach(defendant => {
    result[`defendants.{defendantId:${defendant.defendantId}}.personalInfo`] = defendant.personalInfo || {};
    result[`defendants.{defendantId:${defendant.defendantId}}.insurance`] = defendant.insurance || {};
  });
  return result;
};
